// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCloudServicesAddOnSuccess_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.83333 2C4.4375 2 2.38814 3.71463 2.08129 6.01224C0.844377 6.77327 0 8.11254 0 9.66667C0 12.1053 2.06126 14 4.5 14H5.80269C5.45134 13.3926 5.2034 12.7179 5.08296 12H4.5C3.07275 12 2 10.9099 2 9.66667C2 8.75373 2.56814 7.93409 3.44227 7.55201L4.04636 7.28796L4.04173 6.62869L4.04167 6.61111C4.04167 5.21445 5.245 4 6.83333 4C7.86219 4 8.74366 4.51797 9.22591 5.2656L9.22645 5.26644C9.78698 5.09325 10.3826 5 11 5C12.0743 5 13.0826 5.28234 13.9549 5.77686C13.3917 4.51881 12.0884 3.66667 10.625 3.66667C10.5907 3.66667 10.5565 3.66713 10.5224 3.66805C9.63882 2.64317 8.30811 2 6.83333 2Z" class="svg-bg"/>
  <circle cx="11" cy="11" r="5" fill="#29C192"/>
  <circle cx="11" cy="11" r="5" class="svg-fg-stroke"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5505 9.42999L13.3196 8.19255L9.97867 11.5513L8.39613 9.96032L7.16526 11.1978L8.7478 12.7887L9.97867 14.0262L11.2095 12.7887L14.5505 9.42999Z" class="svg-fg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="18.75" cy="18.75" r="5.25" fill="#3AD2A3"/>
  <path d="M16.0772 17.631L14.823 18.8852L17.9584 22.021L22.9752 17.0042L21.721 15.75L17.9586 19.5124L16.0772 17.631Z" class="svg-fg"/>
  <path d="M5.5 9.5C5.5 7.01472 7.51472 5 10 5C11.8482 5 13.4384 6.1144 14.1311 7.71199L14.5365 8.6471L15.4637 8.22397C15.7782 8.08046 16.1283 8 16.5 8C17.8807 8 19 9.11929 19 10.5C19 10.6801 18.9811 10.8548 18.9456 11.0224L18.8441 11.5006C20.6477 11.5235 22.2925 12.2051 23.5492 13.3157C23.0402 12.1409 22.1332 11.179 20.9989 10.5995C20.9996 10.5664 21 10.5332 21 10.5C21 8.01472 18.9853 6 16.5 6C16.1718 6 15.8513 6.03528 15.5421 6.10238C14.3995 4.24243 12.3457 3 10 3C6.41015 3 3.5 5.91015 3.5 9.5L3.50015 9.54429C1.43522 10.492 0 12.5773 0 15C0 18.3137 2.68629 21 6 21H11.8559C11.6495 20.3671 11.5278 19.696 11.5042 19H6C3.79086 19 2 17.2091 2 15C2 13.1969 3.19378 11.6701 4.83639 11.1716L5.64666 10.9257L5.5377 10.086C5.51287 9.89464 5.5 9.69907 5.5 9.5Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedCloudServicesAddOnSuccess is a generated icon component.
 */
let IconMedCloudServicesAddOnSuccess = IconMedCloudServicesAddOnSuccess_1 = class IconMedCloudServicesAddOnSuccess extends IconBaseElement {
    render() {
        return html `${IconMedCloudServicesAddOnSuccess_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCloudServicesAddOnSuccess.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedCloudServicesAddOnSuccess = IconMedCloudServicesAddOnSuccess_1 = __decorate([
    customElement('zui-icon-med-cloud-services-add-on-success')
], IconMedCloudServicesAddOnSuccess);
export { IconMedCloudServicesAddOnSuccess };
